import { createFileRoute, Navigate } from '@tanstack/react-router';

/** «Chi c'è oggi» è la scheda «Oggi» di «Presenze del personale» dal 03-11-2026: l'indirizzo resta per i segnalibri. */
export const Route = createFileRoute('/_app/workforce/today')({
  component: () => <Navigate to="/hr/presence" search={{ tab: 'today' }} replace />,
});
